module.exports = __webpack_public_path__ + "static/media/festival_boost.68feb62a.png";